{
  "version": 1,
  "asset_id": "6fa1841b-427f-4380-9832-37684047f321",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/6fa1841b-427f-4380-9832-37684047f321/hvac-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/6fa1841b-427f-4380-9832-37684047f321/hvac-thumb.webp",
  "original_filename": "hvac-thumb.webp",
  "size": 4848,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:35Z"
}
